import { structuredTheme } from 'ia-react-core';
import { AppTheme } from '../interfaces/Theme';

const appTheme: AppTheme = {
  ...structuredTheme,
  P: {
    lineHeight: 1.29,
  },
};

export default appTheme;
